import React from 'react';
import { EndSpacer } from './EndSpacer';
import { rosterConfig } from '../../roster-config';

const { TIMELINE_CONTENT_GROUP_HEIGHT } = rosterConfig;

interface CustomersTimelineHeaderProps {
  rowWidth: number;
}

export function CustomersTimelineHeader({ rowWidth }: CustomersTimelineHeaderProps) {
  return (
    <div className='flex-row'>
      <div
        className='roster-gray width-full bordered-bottom'
        style={{ height: `${TIMELINE_CONTENT_GROUP_HEIGHT}px`, minWidth: `${rowWidth}px`, maxWidth: `${rowWidth}px` }}
      />
      {/* Spacer*/}
      <EndSpacer height={56} />
    </div>
  );
}
